import { computed, ref } from 'vue'

/**
 * @import { Ref } from 'vue'
 * @import { Emits } from './emitTypes.js'
 * @import { University } from '../Suggest/useUniversityList.js'
 */

/**
 * @param {string} defaultValue
 * @param {Ref<Array<University>>} itemList
 * @param {Emits<Array<University>>} emits
 */
export const setup = (defaultValue, itemList, emits) => {
  /** @type {Ref<string>} */
  const value = ref(defaultValue)
  /** @type {Ref<Array<University>>} */
  const universityList = ref(itemList)
  /** @type {Ref<boolean>} */
  const focused = ref(false)

  const openSuggestions = computed(() => {
    return itemList.value.length > 0 && focused.value
  })

  /**
   * @param {University} selection
   */
  const onClickOption = selection => {
    emits('selectionChange', selection)
    value.value = selection.text
  }

  /**
   * @param {boolean} value
   */
  const onFocusEvent = value => {
    focused.value = value
  }

  /**
   *
   * @param {Event} event
   */
  const onInput = event => {
    const v = /** @type {HTMLInputElement|null} */ (event.target)?.value ?? ''
    value.value = v
    emits('inputChange', v)
  }

  /**
   *
   * @param {Event} event
   */
  const onChange = event => {
    const v = /** @type {HTMLInputElement|null} */ (event.target)?.value ?? ''
    value.value = v
    emits('textChange', v)
  }

  /** */
  const clearValue = () => {
    value.value = ''
  }

  return {
    value,
    universityList,
    openSuggestions,
    onClickOption,
    onFocusEvent,
    onInput,
    onChange,
    clearValue,
  }
}
